import { OptionI } from '@/utils/forms/optionBuilders'

import { IncidentFiltersFormInputsI } from '../types/form'

export const removeEmptyFilters = (values: IncidentFiltersFormInputsI) => {
  return Object.keys(values).forEach((key) => {
    // Delete null values and empty arrays
    if (values[key] === null || values[key].length == 0) {
      delete values[key]
    }
  })
}

export const compareAlphabetically = (
  a: { name: string },
  b: { name: string }
) => (a.name.toLocaleLowerCase() < b.name.toLocaleLowerCase() ? -1 : 1)

export const dummyDeviceId = '00000000-0000-0000-0000-000000000000'

export const areAllDefined = (...entities: (object | undefined)[]): boolean => {
  return entities.every((entity) => entity !== undefined)
}

export const hasFacilitiesOrFloors = (
  watchFacility: OptionI[] | undefined,
  watchFloor: OptionI[] | undefined
): boolean => watchFacility?.length > 0 || watchFloor?.length > 0
